module.exports = __webpack_public_path__ + "static/img/btn-stamp.aaa1dea8.png";